/**
 * 事業階層（Project Category）のCascaderオプション構築
 *
 * 階層: project_category1 → project_category2 → project_category3
 */

import type { CascaderOption } from '@/shared/ui';
import type { ConvertResultExpenditureProjectCategoryOption } from '../api/generated/model';
import {
  buildHierarchicalCascaderOptions,
  codeNameLevel,
} from './buildHierarchicalCascaderOptions';

/**
 * 事業階層のフラットデータからCascaderオプションを構築
 *
 * @param categories - 事業階層の生データ
 */
export const buildProjectCategoryCascaderOptions = (
  categories: ConvertResultExpenditureProjectCategoryOption[] | null | undefined,
): CascaderOption[] =>
  buildHierarchicalCascaderOptions({
    items: categories,
    levels: [
      codeNameLevel<ConvertResultExpenditureProjectCategoryOption>({
        getCode: (c) => c.project_category1_code,
        getName: (c) => c.project_category1_name,
      }),
      codeNameLevel<ConvertResultExpenditureProjectCategoryOption>({
        getCode: (c) => c.project_category2_code,
        getName: (c) => c.project_category2_name,
      }),
      codeNameLevel<ConvertResultExpenditureProjectCategoryOption>({
        getCode: (c) => c.project_category3_code,
        getName: (c) => c.project_category3_name,
      }),
    ],
  });
